export const sharedStorage = {
  key: 'app-storage',

  getItem: (name: string) => {
    const raw = sessionStorage.getItem(sharedStorage.key);
    const all = raw ? JSON.parse(raw) : {};
    return JSON.stringify(all[name] ?? null);
  },

  setItem: (name: string, value: string) => {
    const raw = sessionStorage.getItem(sharedStorage.key);
    const all = raw ? JSON.parse(raw) : {};
    all[name] = JSON.parse(value);
    sessionStorage.setItem(sharedStorage.key, JSON.stringify(all));
  },

  removeItem: (name: string) => {
    const raw = sessionStorage.getItem(sharedStorage.key);
    const all = raw ? JSON.parse(raw) : {};
    delete all[name];
    sessionStorage.setItem(sharedStorage.key, JSON.stringify(all));
  },
};
